var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "formList",
          rowId: _vm.rowId,
          url: _vm.url,
          "pager-config": _vm.pagerConfig,
          "form-config": _vm.formConfig,
          columns: _vm.columns,
          otherParams: { custId: _vm.custId },
          "checkbox-config": _vm.checkboxConfig,
          cellClick: _vm.chooseRow,
          height: 680,
        },
      }),
      _c(
        "div",
        { staticClass: "footer_func" },
        [
          _c(
            "a-button",
            {
              staticClass: "submit r",
              attrs: { type: "primary" },
              on: { click: _vm.chooseOneRows },
            },
            [_vm._v("确定")]
          ),
          _c("a-button", { staticClass: "r", on: { click: _vm.closePop } }, [
            _vm._v("取消"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }